import { FormSave } from '../../../adapter';

export default async function HandleFormSave(event) {
    // handle request
    const result = await FormSave(event);
    // console.log('data get reponse: ', result);

    return result;
}
